<mat-card class="disclosure-card" appearance="outlined">
  <mat-card-title>
    <span class="title">Acquisitions Notes - {{ milestone.name }}</span>
    <span class="title-actions">
      @if (permsService.userPerms['PROJECTDISCLOSURE']['_']['_edit'] && !readOnly) {
        <button
          class="save"
          [disabled]="waiting"
          mat-stroked-button
          (click)="save()"
          >
          <mat-icon>save</mat-icon>
          Save
        </button>
      }
      <button
        type="button"
        class="collapse-button {{ show ? 'expand' : 'collapse' }}"
        (click)="show = !show"
        >
        <mat-icon>expand_more</mat-icon>
      </button>
    </span>
  </mat-card-title>
  <mat-card-content
    class="disclosure-content {{ show ? 'expand' : 'collapse' }}"
    >
    <!--    <ckeditor-->
    <!--      [(ngModel)]="editorHTML"-->
    <!--      [editor]="Editor"-->
    <!--      [config]="editConfig"-->
    <!--      (change)="onChange($event)"-->
    <!--      [disabled]="!permsService.userPerms['PROJECTDISCLOSURE']['_']['_edit'] || readOnly"-->
  <!--    ></ckeditor>-->
  <angular-editor [config]="editorConfig" [formControl]="editorHTML"></angular-editor>
</mat-card-content>
</mat-card>
